import React from 'react';
import translations from '../../utils/language/translations.json';
import { useTranslation } from 'react-i18next';

const PaginationComponentFeedback = ({
  totalPages,
  currentPage,
  setCurrentPage,
  itemsPerPage,
  setItemsPerPage,
  partialOnly,
}) => {
  const { t: translate, i18n } = useTranslation(); // Correctly destructure `t` and `i18n`
  const currentLang = i18n.language; // Access the current language
  const t = (key) => translations.CardGrid[key][currentLang]; // Adjust the path according to your JSON structure

  const handleChangePage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleChangeItemsPerPage = (event) => {
    setItemsPerPage(Number(event.target.value));
    setCurrentPage(1); // Reset to the first page when changing items per page
  };

  return (
    <div
      className="pagination-controls flex-h"
      style={{ display: "flex", justifyContent: "center" }}
    >
      <button
        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
        disabled={currentPage === 1}
        class="is-sm"
      >
        {t('Previous')}
      </button>
      {Array.from({ length: totalPages }, (_, index) => (
        <button
          key={index + 1}
          onClick={() => handleChangePage(index + 1)}
          className={currentPage === index + 1 ? "active" : ""}
        >
          {index + 1}
        </button>
      ))}
      <button
        onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
        disabled={currentPage === totalPages}
        class="is-sm"
      >
      {t('Next')}
      </button>

      <div
        style={{
          alignContent: "start",
          justifyContent: "flex-start",
          marginTop: "5px",
        }}
      >
       
      
      </div>
    </div>
  );
};

export default PaginationComponentFeedback;
